export default __webpack_public_path__ + "static/MediaContentNine-29f6b2e29f543a1db522e3224613c49c.webp";